import { Controller } from "@hotwired/stimulus";
import { disablePageScroll, enablePageScroll } from "scroll-lock";

const CLASSES = {
    isOpened: "is-opened",
};

export default class extends Controller {
    static targets = ["nav", "toggle"];

    openNav() {
        this.navTarget.classList.add(CLASSES.isOpened);
        this.toggleTarget.classList.add(CLASSES.isOpened);

        disablePageScroll(this.navTarget);
    }

    closeNav() {
        this.navTarget.classList.remove(CLASSES.isOpened);
        this.toggleTarget.classList.remove(CLASSES.isOpened);

        enablePageScroll(this.navTarget);
    }

    toggleNav() {
        const isOpened = this.navTarget.classList.contains(CLASSES.isOpened);

        if (isOpened) {
            this.closeNav();
        } else {
            this.openNav();
        }
    }
}
